import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Send, ExternalLink } from "lucide-react";

/**
 * Public "Apri il bot Telegram" link card.
 * Renders only when the bot is running (configured by admin).
 *
 * variant:
 *   - "compact": small one-line card (good below forms)
 *   - "hero":    larger, sage-bg card (good for landing pages)
 */
export default function BotQuickLink({ variant = "compact", className = "" }) {
  const [bot, setBot] = useState(null);

  useEffect(() => {
    api
      .get("/telegram/info")
      .then((r) => setBot(r.data))
      .catch(() => setBot({ running: false }));
  }, []);

  if (!bot?.running || !bot?.deep_link) return null;

  if (variant === "hero") {
    return (
      <a
        href={bot.deep_link}
        target="_blank"
        rel="noreferrer"
        data-testid="bot-quick-link-hero"
        className={`block bg-primary text-white border border-primary rounded-lg p-6 sm:p-7 group hover:bg-[#436343] active:scale-[0.99] transition-all ${className}`}
      >
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-11 h-11 rounded-md bg-white/15 flex items-center justify-center">
            <Send className="w-5 h-5" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs uppercase tracking-widest font-semibold opacity-80 mb-1">
              Bot Telegram · attivo
            </div>
            <div className="font-display text-xl sm:text-2xl font-semibold leading-tight mb-1">
              Apri @{bot.username}
            </div>
            <div className="text-sm opacity-85">
              Vedi il menu e prenota scrivendo <code className="px-1.5 py-0.5 bg-white/15 rounded text-xs">/menu</code> al bot.
            </div>
          </div>
          <ExternalLink className="w-5 h-5 mt-1 opacity-80 group-hover:translate-x-0.5 transition-transform" />
        </div>
      </a>
    );
  }

  // compact
  return (
    <a
      href={bot.deep_link}
      target="_blank"
      rel="noreferrer"
      data-testid="bot-quick-link-compact"
      className={`block bg-primary/5 border border-primary/30 rounded-md p-3.5 hover:border-primary hover:bg-primary/10 transition-all group ${className}`}
    >
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-md bg-primary text-white flex items-center justify-center flex-shrink-0">
          <Send className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-primary font-semibold">
            Bot Telegram attivo
          </div>
          <div className="font-display font-medium text-sm truncate">
            Apri @{bot.username}
          </div>
        </div>
        <ExternalLink className="w-4 h-4 text-primary group-hover:translate-x-0.5 transition-transform" />
      </div>
    </a>
  );
}
